// Shared fallback UI for both the root Sentry boundary and the per-route
// TanStack Router boundary. Reload is the only universally safe affordance
// — `resetError` from a React boundary only clears the boundary's state, so
// if the underlying cause is a bad bundle or stale state we'd just re-throw.

interface ErrorFallbackProps {
  error: Error
  eventId?: string | null
}

export const ErrorFallback = ({ error, eventId }: ErrorFallbackProps) => (
  <div
    style={{
      padding: '48px 24px',
      minHeight: '60vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: 14,
      textAlign: 'center',
    }}
  >
    <div
      style={{
        fontFamily: 'var(--font-serif)',
        fontSize: 30,
        fontStyle: 'italic',
        color: 'var(--ink)',
        lineHeight: 1.1,
      }}
    >
      Something dropped a card.
    </div>
    <div style={{ fontSize: 14, color: 'var(--ink-2)', maxWidth: 320 }}>
      The screen hit an unexpected error. It's been logged. Reloading usually
      clears it up.
    </div>
    {import.meta.env.DEV && (
      <pre
        style={{
          fontFamily: 'var(--font-mono)',
          fontSize: 11,
          color: 'var(--terra-ink)',
          background: 'var(--paper-2)',
          padding: 10,
          borderRadius: 4,
          maxWidth: '100%',
          overflow: 'auto',
          textAlign: 'left',
          whiteSpace: 'pre-wrap',
        }}
      >
        {error.message}
      </pre>
    )}
    <div style={{ display: 'flex', gap: 8, marginTop: 4 }}>
      <button
        type="button"
        className="btn-stamp"
        onClick={() => window.location.reload()}
      >
        Reload
      </button>
      <button
        type="button"
        className="btn-ghost"
        onClick={() => {
          window.location.href = '/home'
        }}
      >
        Go home
      </button>
    </div>
    {eventId && (
      <div
        style={{
          fontFamily: 'var(--font-mono)',
          fontSize: 10,
          color: 'var(--ink-3)',
          marginTop: 4,
        }}
      >
        ref: {eventId}
      </div>
    )}
  </div>
)
